import React, { Suspense, useEffect } from 'react';
import { Skeleton } from '../';
import { Route } from 'react-router-dom';

const Routing = ({ title, component: Component, struct, ...rest }) => {
  useEffect(() => {
    document.title = `Joinplace - ${title}`;
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  }, []); // eslint-disable-line

  return (
    <Route
      {...rest}
      render={routeProps => (
        <Suspense fallback={<Skeleton active />}>
          <Component {...routeProps} {...struct} />
        </Suspense>
      )}
    />
  );
};

export default Routing;
